import apiService from '../../apiService'
import {
  IAnalysisResult,
  IRecord,
  ITask,
  ITopic,
  ISubmit,
  ITaskParams,
  IRecordParams,
} from './index.d'
// const testId = 123456;
export default {
  /** 查看练习分析 */
  analysis: (
    id: string,
    withGlobalLoading = true
  ): Promise<ISuccessModel<IAnalysisResult>> =>
    apiService.get(
      'clientapi/intelligentdoc/analysis.do',
      {
        id,
      },
      {
        withGlobalLoading,
      }
    ),
  /** 查看参考范文 */
  example: (id: string) =>
    apiService.get('clientapi/intelligentdoc/example.do', { id }),
  /** 查询练习记录 */
  record: (
    params: IRecordParams = { pageNo: 1, pageSize: 10 }
  ): Promise<ISuccessModel<IPageModel<IRecord>>> =>
    apiService.get('clientapi/intelligentdoc/record.do', {
      ...params,
    }),
  /** 查询写作任务列表 */
  getTasks: (
    params: ITaskParams
  ): Promise<ISuccessModel<IPageModel<ITask>>> => {
    return apiService.get('clientapi/intelligentdoc/getMyTask.do', {
      ...params,
      pageNo: params.pageNo || 1,
      pageSize: params.pageSize || 10,
      sortOrder: params.sortOrder || 'ascend',
    })
  },
  /** 获取题目 */
  getTopic: (taskId: string): Promise<ISuccessModel<ITopic>> => {
    return apiService.get(
      'clientapi/intelligentdoc/getTopic.do',
      { taskId },
      { withGlobalLoading: true }
    )
  },
  /** 获取题目 */
  getTopicById: (id: string): Promise<ISuccessModel<ITopic>> => {
    return apiService.get('clientapi/intelligentdoc/getTopicById.do', { id })
  },
  /** 提交 */
  submit: (
    content: string,
    recordId: string
  ): Promise<ISuccessModel<string>> => {
    return apiService.post('clientapi/intelligentdoc/submit.do', {
      content,
      recordId,
    })
  },
  /** 退出写作 */
  quit: (recordId: string, type: number): Promise<ISuccessModel<string>> => {
    return apiService.post('clientapi/intelligentdoc/quit.do', {
      recordId,
      type,
    })
  },
  /** 暂存写作 */
  saveAnswer: (
    answerContent: string,
    recordId: string
  ): Promise<ISuccessModel<string>> => {
    return apiService.post('clientapi/intelligentdoc/saveAnswer.do', {
      answerContent,
      recordId,
    })
  },
  /** 查看原材料 */
  getTopicByRecordId: (taskId: string): Promise<ISuccessModel<ITopic>> => {
    return apiService.get(
      'clientapi/intelligentdoc/getTopicByRecordId.do',
      { recordId: taskId },
      { withGlobalLoading: true }
    )
  },
  /** 测试|练习|自评 开始时长上报 */
  reportStartTime: (recordId: string): Promise<ISuccessModel<ITopic>> => {
    return apiService.get('clientapi/intelligentdoc/reportStartTime.do', {
      recordId,
    })
  },
  /** 测试|练习|自评 时长上报 */
  reportTime: (
    recordId: string,
    time: number
  ): Promise<ISuccessModel<ITopic>> => {
    return apiService.post('clientapi/intelligentdoc/reportLearningTime.do', {
      recordId,
      duration: new Date().getTime() - time,
    })
  },
}
